<template>
  <v-dialog
    scrollable
    :value="value"
    :fullscreen="isMobile()"
    width="1200px"
    @click:outside.stop="closeOperation"
    @keydown.esc="closeOperation"
  >
    <v-card>
      <v-card-title>
        {{ `${getWorkScheduleName()} Shift Details` }}
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <WorkScheduleDetailsTable
        :work-schedule-days="getWorkScheduleDays()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import WorkScheduleDetailsTable from '@/components/approvals/WorkScheduleDetailsTable.vue';
import { mapState } from 'vuex';
import hasAppDialog from '@/mixins/hasAppDialog';
import hasAppSnackbar from '@/mixins/hasAppSnackbar';
import displayAdaptable from '@/mixins/displayAdaptable';

export default {
  name: 'WorkScheduleDetailsDialog',

  components: { WorkScheduleDetailsTable },

  mixins: [hasAppDialog, hasAppSnackbar, displayAdaptable],

  props: {
    value: Boolean,
    workScheduleExternalCode: String,
  },

  computed: {
    ...mapState(['workSchedulesByExternalCode']),
  },

  methods: {
    getWorkScheduleDays() {
      const workSchedule = this.getWorkSchedule();
      return workSchedule ? workSchedule.days : [];
    },

    getWorkSchedule() {
      return this.workSchedulesByExternalCode[this.workScheduleExternalCode];
    },

    getWorkScheduleName() {
      const workSchedule = this.getWorkSchedule();
      return workSchedule ? workSchedule.externalName : '';
    },

    closeOperation() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
